import { pathOr } from 'ramda';

import { IState } from '../../store';

export const virtualTourKeySelector = (state: IState): string | null => {
  return pathOr(null, ['offerData', 'tourV2', 'tourKey'], state);
};
